import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const NotFound = () => {

  const navigate = useNavigate();
  const { t } = useTranslation(["translation", "common"]);

  return (
    <div className="w-full place-content-center h-screen text-center">
      <p className="text-4xl font-semibold">
        {t("notfound.title")}
      </p>
      <p className="text-lg">
        {t("notfound.description")}
      </p>
      <Button
        onClick={() => navigate(-1)}
        className="mt-2"
      >
        {t("common:buttons.back")}
      </Button>
    </div>
  );
};

export default NotFound;
